require("core-js/es6")
require("core-js/stage/3")
window.React = require("react")
window.ReactDOM = require("react-dom")
window.ReactDOMServer = require("react-dom/server")
window.classNames = require("classnames")

window.st = window.st || {}
import * as helpers from "../shared/utils/socialtravel"
Object.keys(helpers).forEach(key => {
  const helper = helpers[key]
  st[key] = helper
})

const requireAll = r => r.keys().forEach(r)
requireAll(require.context('./config/', true, /\.(js)$/))
requireAll(require.context('./common/', true, /\.(js)$/))
requireAll(require.context('./initializers/', true, /\.(js)$/))

require("./features/NewOrderView/init")
require("./features/ProductsCalendarWidget/init")
require("./features/ReviewsListWidget/init")



// WEBPACK FOOTER //
// ./app/webpack/frontend/index.js